const examCategory = state => state.examCategory;
const examList = state => state.examList;
const pagination = state => state.pagination;
const exam = state => state.exam;
const examHistory = state => state.examHistory;
const isLoading = state => state.isLoading;
const isLoadingHistory = state => state.isLoadingHistory;

const examScore = state => state.examScore;
const isLoadingScore = state => state.isLoadingScore;

// Update
const examCombo = state => state.examCombo;
const examDetail = state => state.examDetail;
const examIndexList = state => state.examIndexList;
const examDataList = state => state.examDataList;
const examAudioList = state => state.examAudioList;
const examResponse = state => state.examResponse;
const examState = state => state.examState;

export default {
  examCategory,
  examList,
  pagination,
  exam,
  examHistory,
  examScore,
  isLoadingScore,
  isLoading,
  isLoadingHistory,
  examCombo,
  examDetail,
  examIndexList,
  examDataList,
  examAudioList,
  examResponse,
  examState
};